import React, {Component} from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Icon } from 'semantic-ui-react'
import API_Root from '../../Constants/API_Root'
import API_Backend_Root from "../../Constants/API_Backend_Root";

class AgentsUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            agent: null,
            loading: false,
            error: null,
            currentStep: 1, 
            files: [],
            selectedFiles: [],
            fileDescriptions: {},
            selectedFileForDescription: null,
            agentName: '',
            agentDescription: '',
            agentInstructions: '',
            selectedOutputFormats: [],
            saveSuccess: false,
            runAgentResponse: null,
            runAgentLoading: false,
            jobs: [],
            jobsLoading: false,
            selectedJob: null,
            jobFiles: [],
            jobFilesLoading: false,
            temperature: 0.1,
            topP: 0.9,
            accessKey: null,
            secretKey: null,
            agentAccessKey: null,
            agentSecretKey: null
        };
        this.handleBackToAgents = this.handleBackToAgents.bind(this);
        this.handleDeleteAgent = this.handleDeleteAgent.bind(this);
        this.handleCopyUrl = this.handleCopyUrl.bind(this);
        this.handleStepClick = this.handleStepClick.bind(this);
        this.handleFileSelect = this.handleFileSelect.bind(this);
        this.handleFileDeselect = this.handleFileDeselect.bind(this);
        this.handleFileDescriptionChange = this.handleFileDescriptionChange.bind(this);
        this.handleFileSelectForDescription = this.handleFileSelectForDescription.bind(this);
        this.handleAgentNameChange = this.handleAgentNameChange.bind(this);
        this.handleAgentDescriptionChange = this.handleAgentDescriptionChange.bind(this);
        this.handleAgentInstructionsChange = this.handleAgentInstructionsChange.bind(this);
        this.handleOutputFormatToggle = this.handleOutputFormatToggle.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleUndo = this.handleUndo.bind(this);
        this.handleRunAgent = this.handleRunAgent.bind(this);
        this.handleViewJobDetails = this.handleViewJobDetails.bind(this);
        this.handleBackToJobs = this.handleBackToJobs.bind(this);
        this.handleDownloadJobFile = this.handleDownloadJobFile.bind(this);
    }

    getApiBaseUrl = () => {
        return API_Backend_Root;
    }

    componentDidMount() {
        this.fetchAccountKeys();
    }

    fetchAccountKeys = async () => {
        try {
            const userEmail = localStorage.getItem("email");
            const userToken = localStorage.getItem("token");
            
            if (!userEmail || !userToken) {
                this.setState({ 
                    error: "User authentication not found. Please log in again.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "fetch-account-keys/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: userEmail
                })
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    accessKey: data.access_key,
                    secretKey: data.secret_key
                }, () => {
                    // After setting user keys, fetch agent keys and other data
                    this.fetchAgentKeys();
                    this.fetchUserFiles();
                });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    error: errorData.error || "Failed to fetch account keys",
                    loading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching account keys:', error);
            this.setState({ 
                error: "Network error while fetching account keys",
                loading: false 
            });
        }
    }

    fetchAgentKeys = async () => {
        try {
            const { accessKey, secretKey } = this.state;
            const agentHash = this.props.match.params.agent_hash;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(this.getApiBaseUrl() + `fetch-agent-keys/${agentHash}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify({})
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    agentAccessKey: data.agent_access_key,
                    agentSecretKey: data.agent_secret_key
                }, () => {
                    // After setting agent keys, fetch agent details
                    this.fetchAgentDetails();
                });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    error: errorData.error || "Failed to fetch agent keys",
                    loading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching agent keys:', error);
            this.setState({ 
                error: "Network error while fetching agent keys",
                loading: false 
            });
        }
    }

    fetchAgentDetails = async () => {
        try {
            this.setState({ loading: true, error: null });
            
            const { accessKey, secretKey } = this.state;
            const agentHash = this.props.match.params.agent_hash;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "get-agent-details/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify({
                    agentHash: agentHash 
                })
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch agent details: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
                        
            this.setState({ 
                agent: data.agent,
                agentName: data.agent.agent_name || '',
                agentDescription: data.agent.agent_desc || '',
                agentInstructions: data.agent.agent_instructions || '',
                selectedFiles: data.agent.selected_files || [],
                fileDescriptions: data.agent.file_descriptions || {},
                selectedOutputFormats: data.agent.selected_output_formats || [],
                loading: false 
            });

        } catch (error) {
            console.error('Error fetching agent details:', error);
            this.setState({ 
                error: error.message || "Failed to fetch agent details",
                loading: false 
            });
        }
    };

    fetchUserFiles = async () => {
        try {
            const userEmail = localStorage.getItem("email");
            const userToken = localStorage.getItem("token");
            
            if (!userEmail || !userToken) {
                return;
            }

            const current = new Date();

            const response = await fetch(API_Root + "api/get-api-files/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    utcOffset: current.getTimezoneOffset(),
                    email: userEmail,
                    token: userToken,
                    pkList: null,
                    teamPK: null,
                    importer: false,
                    api: true
                })
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch files: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            const files = [];
            if (data.filePK && data.fileInformation) {
                data.filePK.forEach(filePK => {
                    const fileInfo = data.fileInformation[filePK.id];
                    if (fileInfo) {
                        files.push({
                            pk: filePK.pk,
                            pkID: filePK.id,
                            name: fileInfo.name,
                            fileType: fileInfo.inputType,
                            createdDt: fileInfo.createdDt,
                            fileHash: fileInfo.fileHash
                        });
                    }
                });
            }
            
            this.setState({ files: files });

        } catch (error) {
            console.error('Error fetching files:', error);
        }
    };

    handleBackToAgents = () => {
        this.props.navigateTo('/ai');
    }

    handleDeleteAgent = async () => {
        // Show confirmation dialog
        const confirmed = window.confirm(
            'Are you sure you want to delete this agent? This action will permanently delete:\n\n' +
            '• The agent and all its settings\n' +
            '• All job history and results\n' +
            '• All generated files\n\n' +
            'This action cannot be undone.'
        );
        
        if (!confirmed) {
            return;
        }
        
        try {
            this.setState({ loading: true, error: null });
            
            const { accessKey, secretKey } = this.state;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    loading: false 
                });
                return;
            }
            
            const response = await fetch(this.getApiBaseUrl() + `delete-agent/${this.state.agent.agent_hash}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify({})
            });
            
            if (!response.ok) {
                throw new Error(`Failed to delete agent: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
                    
            // Show success message
            alert('Agent deleted successfully!');
            
            // Navigate back to agents list
            this.props.navigateTo('/ai');
            
        } catch (error) {
            console.error('Error deleting agent:', error);
            this.setState({ 
                error: error.message || "Failed to delete agent",
                loading: false 
            });
        }
    }

    handleCopyUrl = () => {
        const agentUrl = `https://api.apispreadsheets.com/agents/${this.state.agent.agent_hash}`;
        navigator.clipboard.writeText(agentUrl).then(() => {
            console.log('URL copied to clipboard');
        }).catch(err => {
            console.error('Failed to copy URL: ', err);
        });
    }

    handleStepClick = (stepNumber) => {
        this.setState({ currentStep: stepNumber });
        
        // Fetch jobs when Jobs tab is selected
        if (stepNumber === 4 && this.state.jobs.length === 0 && !this.state.jobsLoading) {
            this.fetchAgentJobs();
        }
    }

    handleFileSelect = (fileHash) => {
        if (this.state.selectedFiles.length >= 20) {
            console.log('Maximum of 20 files allowed');
            return;
        }
        
        this.setState(prevState => {
            const newSelectedFiles = [...prevState.selectedFiles, fileHash];
            return { selectedFiles: newSelectedFiles };
        });
    }

    handleFileDeselect = (fileHash) => {
        this.setState(prevState => {
            const newSelectedFiles = prevState.selectedFiles.filter(id => id !== fileHash);
            return { selectedFiles: newSelectedFiles };
        });
    }

    handleFileDescriptionChange = (fileHash, description) => {
        this.setState(prevState => ({
            fileDescriptions: {
                ...prevState.fileDescriptions,
                [fileHash]: description
            }
        }));
    }

    handleFileSelectForDescription = (fileHash) => {
        this.setState({ selectedFileForDescription: fileHash });
    }

    handleAgentNameChange = (e) => {
        this.setState({ agentName: e.target.value });
    }

    handleAgentDescriptionChange = (e) => {
        this.setState({ agentDescription: e.target.value });
    }

    handleAgentInstructionsChange = (e) => {
        this.setState({ agentInstructions: e.target.value });
    }

    handleOutputFormatToggle = (format) => {
        this.setState(prevState => {
            const isSelected = prevState.selectedOutputFormats.includes(format);
            const newSelectedFormats = isSelected
                ? prevState.selectedOutputFormats.filter(f => f !== format)
                : [...prevState.selectedOutputFormats, format];
            
            return { selectedOutputFormats: newSelectedFormats };
        });
    }

    handleSave = async () => {
        try {
            this.setState({ loading: true, error: null, saveSuccess: false });
            
            const { accessKey, secretKey } = this.state;
            const agentHash = this.props.match.params.agent_hash; 
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    loading: false 
                });
                return;
            }

            const requestBody = {
                agentHash: agentHash,
                agentName: this.state.agentName,
                agentDescription: this.state.agentDescription,
                selectedFiles: this.state.selectedFiles,
                fileDescriptions: this.state.fileDescriptions,
                selectedOutputFormats: this.state.selectedOutputFormats,
                agentInstructions: this.state.agentInstructions
            };

            const response = await fetch(this.getApiBaseUrl() + "update-agent", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                throw new Error(`Failed to update agent: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            this.setState({ 
                loading: false,
                agent: data.agent,
                saveSuccess: true,
                runAgentResponse: null  // Add this line to clear the old response
            });

            setTimeout(() => {
                this.setState({ saveSuccess: false });
            }, 3000);
            
        } catch (error) {
            console.error('Error updating agent:', error);
            this.setState({ 
                error: error.message || "Failed to update agent",
                loading: false 
            });
        }
    }

    handleUndo = () => {
        if (this.state.agent) {
            this.setState({
                agentName: this.state.agent.agent_name || '',
                agentDescription: this.state.agent.agent_desc || '',
                agentInstructions: this.state.agent.agent_instructions || '', // Changed from agent_instruction to agent_instructions
                selectedFiles: this.state.agent.selected_files || [],
                fileDescriptions: this.state.agent.file_descriptions || {},
                selectedOutputFormats: this.state.agent.selected_output_formats || []
            });
        }
    }

    handleRunAgent = async () => {
        try {
            this.setState({ runAgentLoading: true, error: null });
            
            const agentHash = this.props.match.params.agent_hash;
            
            if (!this.state.agent || !this.state.agent.access_key || !this.state.agent.secret_key) {
                this.setState({ 
                    error: "Agent credentials not found. Please refresh the page.",
                    runAgentLoading: false 
                });
                return;
            }
            
            const response = await fetch(this.getApiBaseUrl() + `agents/${agentHash}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': this.state.agent.access_key,
                    'secretKey': this.state.agent.secret_key
                },
                body: JSON.stringify({
                    temperature: this.state.temperature,
                    top_p: this.state.topP
                })
            });
    
            if (!response.ok) {
                throw new Error(`Failed to run agent: ${response.status}`);
            }
    
            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            this.setState({ 
                runAgentLoading: false,
                runAgentResponse: data
            });
            
        } catch (error) {
            console.error('Error running agent:', error);
            this.setState({ 
                error: error.message || "Failed to run agent",
                runAgentLoading: false 
            });
        }
    }

    fetchAgentJobs = async () => {
        try {
            this.setState({ jobsLoading: true, error: null });
            
            const { agentAccessKey, agentSecretKey } = this.state;
            const agentHash = this.props.match.params.agent_hash;
            
            if (!agentAccessKey || !agentSecretKey) {
                this.setState({ 
                    error: "Agent keys not available. Please refresh the page.",
                    jobsLoading: false 
                });
                return;
            }

            const response = await fetch(this.getApiBaseUrl() + `get-agent-jobs/${agentHash}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': agentAccessKey,
                    'secretKey': agentSecretKey
                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch agent jobs: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            this.setState({ 
                jobs: data.jobs || [],
                jobsLoading: false 
            });

        } catch (error) {
            console.error('Error fetching agent jobs:', error);
            this.setState({ 
                error: error.message || "Failed to fetch agent jobs",
                jobsLoading: false 
            });
        }
    };

    handleViewJobDetails = (job) => {
        this.fetchJobDetails(job);
    };

    fetchJobDetails = async (job) => {
        try {
            this.setState({ jobFilesLoading: true, error: null });
            
            const { agentAccessKey, agentSecretKey } = this.state;
            const agentHash = this.props.match.params.agent_hash;
            
            if (!agentAccessKey || !agentSecretKey) {
                this.setState({ 
                    error: "Agent keys not available. Please refresh the page.",
                    jobFilesLoading: false 
                });
                return;
            }

            const response = await fetch(this.getApiBaseUrl() + `get-job-details/${agentHash}/${job.id}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': agentAccessKey,
                    'secretKey': agentSecretKey
                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch job details: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            this.setState({ 
                selectedJob: job,
                jobFiles: data.files || [],
                jobFilesLoading: false 
            });

        } catch (error) {
            console.error('Error fetching job details:', error);
            this.setState({ 
                error: error.message || "Failed to fetch job details",
                jobFilesLoading: false 
            });
        }
    };

    handleBackToJobs = () => {
        this.setState({ 
            selectedJob: null, 
            jobFiles: [], 
            jobFilesLoading: false 
        });
    };

    handleDownloadJobFile = (file) => {
        try {
            // If there's a download URL in the file info, use it
            if (file.file_info && file.file_info.download_url) {
                window.open(file.file_info.download_url, '_blank');
                return;
            }
            
            // Otherwise, try to download from S3 using the s3_key
            if (file.file_info && file.file_info.s3_key) {
                
            }
            
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };

    handleTemperatureChange = (e) => {
        this.setState({ temperature: parseFloat(e.target.value) });
    };

    handleTopPChange = (e) => {
        this.setState({ topP: parseFloat(e.target.value) });
    };

    handleDownloadFile = (fileData) => {
        try {
            // Decode base64 content
            const binaryString = atob(fileData.content);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            
            // Create blob and download
            const blob = new Blob([bytes], { type: fileData.content_type });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileData.filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    renderStepContent = () => {
        switch(this.state.currentStep) {
            case 1: // Files
                return (
                    <div style={{ padding: '20px' }}>
                        <h3 style={{ marginBottom: '20px', color: '#333' }}>Files</h3>
                        
                        {this.state.files.length === 0 ? (
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '40px', 
                                color: '#666',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '6px'
                            }}>
                                No files found.
                            </div>
                        ) : (
                            <div style={{ 
                                display: 'grid', 
                                gap: '10px',
                                maxHeight: '400px',
                                overflowY: 'auto'
                            }}>
                                {this.state.files.map(file => (
                                    <div
                                        key={file.pkID}
                                        onClick={() => {
                                            if (this.state.selectedFiles.includes(file.fileHash)) {
                                                this.handleFileDeselect(file.fileHash);
                                            } else {
                                                this.handleFileSelect(file.fileHash);
                                            }
                                        }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '12px 16px',
                                            border: this.state.selectedFiles.includes(file.fileHash) 
                                                ? '2px solid #70BB98' 
                                                : '1px solid #ddd',
                                            borderRadius: '6px',
                                            backgroundColor: this.state.selectedFiles.includes(file.fileHash) 
                                                ? '#f0f8f5' 
                                                : 'white',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            minWidth: 0,
                                            wordBreak: 'break-word'
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedFiles.includes(file.fileHash)}
                                            onChange={() => {}}
                                            style={{ marginRight: '12px', flexShrink: 0 }}
                                        />
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ 
                                                fontWeight: '500', 
                                                color: '#333',
                                                marginBottom: '4px',
                                                wordBreak: 'break-word',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}>
                                                {file.name || 'Untitled File'}
                                            </div>
                                            <div style={{ 
                                                fontSize: '12px', 
                                                color: '#666',
                                                wordBreak: 'break-word'
                                            }}>
                                                {file.fileType || 'Unknown type'} • 
                                                {file.createdDt ? new Date(file.createdDt).toLocaleDateString() : 'Unknown date'}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                );
            case 2: // Build
                return (
                    <div style={{ padding: '20px' }}>
                        <h3 style={{ marginBottom: '24px', color: '#333' }}>Build Agent</h3>
                        
                        <div style={{ marginBottom: '20px' }}>
                            <div>
                                <h4 style={{ 
                                    marginBottom: '16px', 
                                    color: '#333',
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    Agent Name
                                </h4>
                                <input
                                    type="text"
                                    placeholder="Enter a name for your agent..."
                                    value={this.state.agentName}
                                    onChange={this.handleAgentNameChange}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        fontFamily: 'Lato, sans-serif',
                                        outline: 'none',
                                        marginBottom: '20px'
                                    }}
                                />
                            </div>
                            <div>
                                <h4 style={{ 
                                    marginBottom: '16px', 
                                    color: '#333',
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    Agent Description
                                </h4>
                                <input
                                    type="text"
                                    placeholder="Briefly describe what this agent does..."
                                    value={this.state.agentDescription}
                                    onChange={this.handleAgentDescriptionChange}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        fontFamily: 'Lato, sans-serif',
                                        outline: 'none'
                                    }}
                                />
                            </div>
                        </div>
                        
                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ 
                                marginBottom: '16px', 
                                color: '#333',
                                fontSize: '18px',
                                fontWeight: '600'
                            }}>
                                Agent Instructions
                            </h4>
                            <textarea
                                placeholder="Enter instructions for your AI agent..."
                                value={this.state.agentInstructions}
                                onChange={this.handleAgentInstructionsChange}
                                style={{
                                    width: '100%',
                                    minHeight: '300px',
                                    maxHeight: '500px',
                                    padding: '12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    fontFamily: 'Lato, sans-serif',
                                    resize: 'vertical',
                                    outline: 'none',
                                    overflow: 'auto'
                                }}
                            />
                        </div>

                        {/* File Descriptions Section  */}
                        {this.state.selectedFiles.length > 0 && (
                            <div style={{ marginBottom: '20px' }}>
                                <h4 style={{ 
                                    marginBottom: '16px', 
                                    color: '#333',
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    File Descriptions
                                </h4>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 2fr',
                                    gap: '20px',
                                    height: '300px',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    overflow: 'hidden'
                                }}>
                                    {/* Left column - File list */}
                                    <div style={{
                                        backgroundColor: '#f8f9fa',
                                        borderRight: '1px solid #ddd',
                                        overflowY: 'auto'
                                    }}>
                                        {this.state.selectedFiles.map(fileHash => {
                                            const file = this.state.files.find(f => f.fileHash === fileHash);
                                            const isSelected = this.state.selectedFileForDescription === fileHash;
                                            return (
                                                <div
                                                    key={fileHash}
                                                    onClick={() => this.handleFileSelectForDescription(fileHash)}
                                                    style={{
                                                        padding: '12px 16px',
                                                        cursor: 'pointer',
                                                        backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                                                        borderBottom: '1px solid #e0e0e0',
                                                        transition: 'background-color 0.2s ease',
                                                        borderLeft: isSelected ? '3px solid #70BB98' : '3px solid transparent'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (!isSelected) {
                                                            e.target.style.backgroundColor = '#f0f0f0';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!isSelected) {
                                                            e.target.style.backgroundColor = 'transparent';
                                                        }
                                                    }}
                                                >
                                                    <div style={{ 
                                                        fontWeight: isSelected ? '600' : '500', 
                                                        color: '#333',
                                                        marginBottom: '4px',
                                                        fontSize: '14px'
                                                    }}>
                                                        {file ? file.name : `File ${fileHash}`}
                                                    </div>
                                                    <div style={{ 
                                                        fontSize: '12px', 
                                                        color: '#666' 
                                                    }}>
                                                        {file ? file.fileType : 'Unknown type'}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* Right column - Description textarea */}
                                    <div style={{ padding: '16px' }}>
                                        {this.state.selectedFileForDescription ? (
                                            <div>
                                                <label style={{ 
                                                    display: 'block', 
                                                    marginBottom: '8px', 
                                                    fontWeight: '500', 
                                                    color: '#333',
                                                    fontSize: '14px'
                                                }}>
                                                    Description for {(() => {
                                                        const selectedFile = this.state.files.find(f => f.fileHash === this.state.selectedFileForDescription);
                                                        return selectedFile ? selectedFile.name : `File ${this.state.selectedFileForDescription}`;
                                                    })()}
                                                </label>
                                                <textarea
                                                    placeholder="Describe what this file contains and how it should be used..."
                                                    value={this.state.fileDescriptions[this.state.selectedFileForDescription] || ''}
                                                    onChange={(e) => this.handleFileDescriptionChange(this.state.selectedFileForDescription, e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        padding: '12px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '6px',
                                                        fontSize: '14px',
                                                        fontFamily: 'Lato, sans-serif',
                                                        resize: 'vertical',
                                                        outline: 'none'
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%',
                                                color: '#666',
                                                fontSize: '14px',
                                                textAlign: 'center'
                                            }}>
                                                Select a file from the left to add a description
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ 
                                marginBottom: '16px', 
                                color: '#333',
                                fontSize: '18px',
                                fontWeight: '600'
                            }}>
                                Output File Formats
                            </h4>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '8px',
                                marginBottom: '16px'
                            }}>
                                {['.xlsx', '.pdf', '.html', '.docx', '.csv'].map(format => {
                                    const isSelected = this.state.selectedOutputFormats.includes(format);
                                    return (
                                        <button
                                            key={format}
                                            onClick={() => this.handleOutputFormatToggle(format)}
                                            style={{
                                                padding: '8px 16px',
                                                border: isSelected ? '2px solid #70BB98' : '1px solid #ddd',
                                                borderRadius: '6px',
                                                backgroundColor: isSelected ? '#f0f8f5' : 'white',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                color: isSelected ? '#70BB98' : '#333',
                                                transition: 'all 0.2s ease',
                                                outline: 'none'
                                            }}
                                        >
                                            {format}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                );
            case 3: // API
                return (
                    <div style={{ padding: '20px' }}>
                        <h3 style={{ marginBottom: '20px', color: '#333' }}>API Playground</h3>
                        
                        {/* API URL Section */}
                        <div style={{ marginBottom: '24px' }}>
                            <div className="codeFileURL" style={{ border: '1px solid rgb(221, 221, 221)' }}>
                                <div style={{marginBottom: "6px"}}>
                                    <span>
                                        <span style={{verticalAlign: "middle", fontSize: "16px", color: "#161E16", fontWeight: "700", fontFamily: "Lato"}}>
                                            <i className='bx bx-window-alt' style={{color: "#9696A0", fontSize: "20px", verticalAlign: "middle"}} />
                                            <span style={{paddingLeft: "4px", marginTop: "5px"}}>API URL</span>
                                        </span>
                                        <span style={{ backgroundColor: "orange", color: "white", fontSize: "85%", padding: "0 4px 0 4px", fontWeight: "700", marginLeft: "6px"}}>POST</span>
                                    </span>
                                </div>
                                <p className="wordwrap apiURLText" style={{ margin: 0, padding: '8px 6px 8px 12px' }}>
                                    <Icon name="copy outline"
                                          className="fileIDLabelIcon"
                                          color="green"
                                          style={{cursor: "pointer"}}
                                          onClick={this.handleCopyUrl}
                                    />
                                    {`https://api.apispreadsheets.com/agents/${this.state.agent.agent_hash}`}
                                </p>
                            </div>
                        </div>

                        {/* Agent ID Section */}
                        <div style={{ marginBottom: '24px' }}>
                            <h4 style={{ 
                                marginBottom: '12px', 
                                color: '#333',
                                fontSize: '16px',
                                fontWeight: '600'
                            }}>
                                Agent ID
                            </h4>
                            <div style={{
                                padding: '12px 16px',
                                backgroundColor: '#f8f9fa',
                                border: '1px solid #ddd',
                                borderRadius: '6px',
                                fontFamily: 'monospace',
                                fontSize: '14px',
                                color: '#333'
                            }}>
                                {this.state.agent.agent_hash}
                            </div>
                        </div>

                        {/* Model Settings Section */}
                        <div style={{ marginBottom: '24px' }}>
                            <h4 style={{ 
                                marginBottom: '16px', 
                                color: '#333',
                                fontSize: '16px',
                                fontWeight: '600'
                            }}>
                                Model Settings
                            </h4>
                            
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                {/* Temperature Slider */}
                                <div>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '8px', 
                                        fontWeight: '500', 
                                        color: '#333',
                                        fontSize: '14px'
                                    }}>
                                        Temperature: {this.state.temperature}
                                    </label>
                                    <input
                                        type="range"
                                        min="0"
                                        max="2"
                                        step="0.1"
                                        value={this.state.temperature}
                                        onChange={this.handleTemperatureChange}
                                        className="custom-slider"
                                    />
                                    <div style={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between', 
                                        fontSize: '12px', 
                                        color: '#666',
                                        marginTop: '4px'
                                    }}>
                                        <span>0 (Deterministic)</span>
                                        <span>2 (Creative)</span>
                                    </div>
                                </div>
                                
                                {/* Top P Slider */}
                                <div>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '8px', 
                                        fontWeight: '500', 
                                        color: '#333',
                                        fontSize: '14px'
                                    }}>
                                        Top P: {this.state.topP}
                                    </label>
                                    <input
                                        type="range"
                                        min="0"
                                        max="1"
                                        step="0.1"
                                        value={this.state.topP}
                                        onChange={this.handleTopPChange}
                                        className="custom-slider"
                                    />
                                    <div style={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between', 
                                        fontSize: '12px', 
                                        color: '#666',
                                        marginTop: '4px'
                                    }}>
                                        <span>0 (Focused)</span>
                                        <span>1 (Diverse)</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Selected Files Section - Simple list view */}
                        <div style={{ marginBottom: '24px' }}>
                            <h4 style={{ 
                                marginBottom: '12px', 
                                color: '#333',
                                fontSize: '16px',
                                fontWeight: '600'
                            }}>
                                Selected Files ({this.state.selectedFiles.length})
                            </h4>
                            
                            {this.state.selectedFiles.length === 0 ? (
                                <div style={{ 
                                    textAlign: 'center', 
                                    padding: '20px', 
                                    color: '#666',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '6px',
                                    fontSize: '14px'
                                }}>
                                    No files selected for this agent
                                </div>
                            ) : (
                                <div style={{ 
                                    display: 'grid', 
                                    gap: '8px',
                                    maxHeight: '300px',
                                    overflowY: 'auto'
                                }}>
                                    {this.state.selectedFiles.map(fileHash => {
                                        const file = this.state.files.find(f => f.fileHash === fileHash);
                                        return (
                                            <div
                                                key={fileHash}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '12px 16px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '6px',
                                                    backgroundColor: 'white'
                                                }}
                                            >
                                                <div style={{ 
                                                    width: '8px', 
                                                    height: '8px', 
                                                    backgroundColor: '#70BB98', 
                                                    borderRadius: '50%', 
                                                    marginRight: '12px' 
                                                }}></div>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ 
                                                        fontWeight: '500', 
                                                        color: '#333',
                                                        marginBottom: '4px',
                                                        fontSize: '14px'
                                                    }}>
                                                        {file ? file.name : `File ${fileHash}`}
                                                    </div>
                                                    <div style={{ 
                                                        fontSize: '12px', 
                                                        color: '#666' 
                                                    }}>
                                                        {file ? file.fileType : 'Unknown type'} • 
                                                        {file ? (file.createdDt ? new Date(file.createdDt).toLocaleDateString() : 'Unknown date') : 'File not found'}
                                                    </div>
                                                </div>
                                                <div style={{ 
                                                    fontSize: '11px', 
                                                    color: '#999',
                                                    fontFamily: 'monospace',
                                                    backgroundColor: '#f0f0f0',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px'
                                                }}>
                                                    {fileHash}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        {/* API Response Section */}
                        <div style={{ 
                            textAlign: 'center', 
                            padding: '20px', 
                            color: '#666',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '6px',
                            fontSize: '14px'
                        }}>
                            {this.state.runAgentLoading ? (
                                <div>
                                    <div style={{ marginBottom: '12px' }}>Running agent...</div>
                                    <div style={{ 
                                        width: '20px', 
                                        height: '20px', 
                                        border: '2px solid #f3f3f3',
                                        borderTop: '2px solid #70BB98',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite',
                                        margin: '0 auto'
                                    }}></div>
                                </div>
                            ) : this.state.runAgentResponse ? (
                                <div style={{ textAlign: 'left' }}>
                                    <h4 style={{ 
                                        marginBottom: '16px', 
                                        color: '#333',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        textAlign: 'center'
                                    }}>
                                        Response
                                    </h4>
                                    
                                    {/* Download Files Section */}
                                    {this.state.runAgentResponse.external_api_result && 
                                     this.state.runAgentResponse.external_api_result.results && 
                                     this.state.runAgentResponse.external_api_result.results.length > 0 && (
                                        <div style={{ marginBottom: '20px' }}>
                                            <h5 style={{ 
                                                marginBottom: '12px', 
                                                color: '#333',
                                                fontSize: '14px',
                                                fontWeight: '600'
                                            }}>
                                                Generated Files
                                            </h5>
                                            
                                        
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                {this.state.runAgentResponse.external_api_result.results.map((result, index) => {
                                                    // Get the original filename from the input_file or construct it
                                                    let originalFilename = result.input_file;
                                                    
                                                    // If input_file is not available or is just a hash, try to find the original name
                                                    if (!originalFilename || originalFilename.length < 10) {
                                                        // Look for the original filename in our files list
                                                        const matchingFile = this.state.files.find(file => 
                                                            result.output_file.includes(file.name) || 
                                                            file.fileHash === originalFilename
                                                        );
                                                        if (matchingFile) {
                                                            originalFilename = matchingFile.name;
                                                        }
                                                    }
                                                    
                                                    // Extract just the filename without path
                                                    if (originalFilename && originalFilename.includes('/')) {
                                                        originalFilename = originalFilename.split('/').pop();
                                                    }
                                                    
                                                    // Construct the new message
                                                    const displayMessage = originalFilename ? 
                                                        `downloaded ${originalFilename} -> ${result.output_file}` : 
                                                        result.message; // Fallback to original message if we can't determine original filename
                                                    
                                                    return (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                padding: '12px 16px',
                                                                border: '1px solid #ddd',
                                                                borderRadius: '6px',
                                                                backgroundColor: 'white'
                                                            }}
                                                        >
                                                            <div>
                                                                <div style={{ 
                                                                    fontWeight: '500', 
                                                                    color: '#333',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    {result.output_file}
                                                                </div>
                                                                <div style={{ 
                                                                    fontSize: '12px', 
                                                                    color: result.success ? '#28a745' : '#dc3545'
                                                                }}>
                                                                    {displayMessage}
                                                                </div>
                                                                <div style={{ 
                                                                    fontSize: '10px', 
                                                                    color: '#666',
                                                                    marginTop: '4px'
                                                                }}>
                                                                    Success: {result.success ? 'Yes' : 'No'} | Has file_data: {result.file_data ? 'Yes' : 'No'}
                                                                </div>
                                                            </div>
                                                            {result.success && result.file_data && (
                                                                <button
                                                                    onClick={() => this.handleDownloadFile(result.file_data)}
                                                                    style={{
                                                                        backgroundColor: '#70BB98',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        padding: '8px 16px',
                                                                        fontSize: '12px',
                                                                        fontWeight: '500',
                                                                        cursor: 'pointer',
                                                                        outline: 'none',
                                                                        transition: 'background-color 0.2s ease'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.backgroundColor = '#5da085';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.backgroundColor = '#70BB98';
                                                                    }}
                                                                >
                                                                    Download
                                                                </button>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* Filtered Response Data - Only show essential agent info */}
                                    <pre style={{
                                        backgroundColor: '#f8f9fa',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        padding: '16px',
                                        fontSize: '12px',
                                        color: '#333',
                                        overflow: 'auto',
                                        maxHeight: '400px',
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word',
                                        minWidth: 0
                                    }}>
                                        {JSON.stringify({
                                            agent_hash: this.state.runAgentResponse.agent_id,
                                            agent_name: this.state.runAgentResponse.agent_name,
                                            agent_description: this.state.runAgentResponse.agent_description,
                                            agent_instructions: this.state.runAgentResponse.agent_instructions,
                                            selected_files: this.state.runAgentResponse.selected_files,
                                            file_descriptions: this.state.runAgentResponse.file_descriptions,
                                            selected_output_formats: this.state.runAgentResponse.selected_output_formats,
                                            job_hash: this.state.runAgentResponse.job_hash  // Add this line
                                        }, null, 2)}
                                    </pre>
                                </div>
                            ) : (
                                'Click "Run Agent" to see the response here or click the Jobs tab'
                            )}
                        </div>
                    </div>
                );
            case 4: // Jobs
                // If a job is selected, show job details
                if (this.state.selectedJob) {
                    return (
                        <div style={{ padding: '20px' }}>
                            {/* Back button */}
                            <div style={{ marginBottom: '20px' }}>
                                <button
                                    onClick={this.handleBackToJobs}
                                    style={{
                                        backgroundColor: '#6c757d',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        padding: '8px 16px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                        outline: 'none',
                                        transition: 'background-color 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#5a6268';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#6c757d';
                                    }}
                                >
                                    ← Back to Jobs
                                </button>
                            </div>

                            {/* Job Details Header */}
                            <div style={{ marginBottom: '24px' }}>
                                <h3 style={{ marginBottom: '8px', color: '#333' }}>
                                    Job {this.state.selectedJob.job_hash} Details</h3>
                                <div style={{ 
                                    fontSize: '14px', 
                                    color: '#666',
                                    marginBottom: '4px'
                                }}>
                                    Status: <span style={{ 
                                        color: this.state.selectedJob.status === 'completed' ? '#28a745' : 
                                              this.state.selectedJob.status === 'failed' ? '#dc3545' : 
                                              this.state.selectedJob.status === 'running' ? '#ffc107' : '#6c757d',
                                        fontWeight: '500'
                                    }}>
                                        {this.state.selectedJob.status}
                                    </span>
                                </div>
                                <div style={{ 
                                    fontSize: '12px', 
                                    color: '#999'
                                }}>
                                    Created: {this.state.selectedJob.created_dt ? new Date(this.state.selectedJob.created_dt).toLocaleString() : 'Unknown'}
                                </div>
                            </div>

                            {/* Generated Files Section */}
                            <div style={{ marginBottom: '24px' }}>
                                <h4 style={{ 
                                    marginBottom: '16px', 
                                    color: '#333',
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    Generated Files
                                </h4>
                                
                                {this.state.jobFilesLoading ? (
                                    <div style={{ 
                                        textAlign: 'center', 
                                        padding: '40px', 
                                        color: '#666',
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: '6px'
                                    }}>
                                        <div style={{ marginBottom: '12px' }}>Loading files...</div>
                                        <div style={{ 
                                            width: '20px', 
                                            height: '20px', 
                                            border: '2px solid #f3f3f3',
                                            borderTop: '2px solid #70BB98',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite',
                                            margin: '0 auto'
                                        }}></div>
                                    </div>
                                ) : this.state.jobFiles.length === 0 ? (
                                    <div style={{ 
                                        textAlign: 'center', 
                                        padding: '40px', 
                                        color: '#666',
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: '6px'
                                    }}>
                                        No files found for this job.
                                    </div>
                                ) : (
                                    <div style={{ 
                                        display: 'grid', 
                                        gap: '12px',
                                        maxHeight: '400px',
                                        overflowY: 'auto'
                                    }}>
                                        {this.state.jobFiles.map((file, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    padding: '16px 20px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '8px',
                                                    backgroundColor: 'white',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ 
                                                        fontWeight: '600', 
                                                        color: '#333',
                                                        marginBottom: '8px',
                                                        fontSize: '16px'
                                                    }}>
                                                        {file.filename}
                                                    </div>
                                                    <div style={{ 
                                                        fontSize: '14px', 
                                                        color: '#666',
                                                        marginBottom: '4px'
                                                    }}>
                                                        {file.file_info && file.file_info.original_filename ? 
                                                            `downloaded ${file.file_info.original_filename} -> ${file.filename}` : 
                                                            file.filename
                                                        }
                                                    </div>
                                                    <div style={{ 
                                                        fontSize: '12px', 
                                                        color: '#999'
                                                    }}>
                                                        Size: {file.file_info && file.file_info.file_size ? `${Math.round(file.file_info.file_size / 1024)} KB` : 'Unknown'} | 
                                                        Type: {file.file_info && file.file_info.content_type ? file.file_info.content_type : 'Unknown'}
                                                    </div>
                                                </div>
                                                <div style={{ 
                                                    display: 'flex', 
                                                    flexDirection: 'column', 
                                                    gap: '8px',
                                                    alignItems: 'flex-end'
                                                }}>
                                                    <button
                                                        onClick={() => this.handleDownloadJobFile(file)}
                                                        style={{
                                                            backgroundColor: '#70BB98',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            padding: '8px 16px',
                                                            fontSize: '12px',
                                                            fontWeight: '500',
                                                            cursor: 'pointer',
                                                            outline: 'none',
                                                            transition: 'background-color 0.2s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = '#5da085';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = '#70BB98';
                                                        }}
                                                    >
                                                        Download
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Job Info Section */}
                            <div style={{ marginBottom: '24px' }}>
                                <h4 style={{ 
                                    marginBottom: '16px', 
                                    color: '#333',
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    Job Information
                                </h4>
                                <pre style={{
                                    backgroundColor: '#f8f9fa',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    padding: '16px',
                                    fontSize: '12px',
                                    color: '#333',
                                    overflow: 'auto',
                                    maxHeight: '300px',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                    minWidth: 0
                                }}>
                                    {JSON.stringify({
                                        job_id: this.state.selectedJob.id,
                                        job_hash: this.state.selectedJob.job_hash,
                                        status: this.state.selectedJob.status,
                                        created_dt: this.state.selectedJob.created_dt,
                                        updated_dt: this.state.selectedJob.updated_dt,
                                        job_info: this.state.selectedJob.job_info ? 
                                            Object.keys(this.state.selectedJob.job_info).reduce((filtered, key) => {
                                                if (key !== 'file_data') {
                                                    // If this is the external_api_result, also filter out file_data from its results
                                                    if (key === 'external_api_result' && this.state.selectedJob.job_info[key] && this.state.selectedJob.job_info[key].results) {
                                                        filtered[key] = {
                                                            ...this.state.selectedJob.job_info[key],
                                                            results: this.state.selectedJob.job_info[key].results.map(result => {
                                                                if (result && typeof result === 'object' && 'file_data' in result) {
                                                                    const { file_data, ...resultWithoutFileData } = result;
                                                                    return resultWithoutFileData;
                                                                }
                                                                return result;
                                                            })
                                                        };
                                                    } else {
                                                        filtered[key] = this.state.selectedJob.job_info[key];
                                                    }
                                                }
                                                return filtered;
                                            }, {}) : 
                                            this.state.selectedJob.job_info
                                    }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    );
                }

                // Original jobs list view
                return (
                    <div style={{ padding: '20px' }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'space-between',
                            marginBottom: '20px'
                        }}>
                            <h3 style={{ margin: 0, color: '#333' }}>Agent Jobs</h3>
                            <button
                                onClick={this.fetchAgentJobs}
                                disabled={this.state.jobsLoading}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#70BB98',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: this.state.jobsLoading ? 'not-allowed' : 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    opacity: this.state.jobsLoading ? 0.6 : 1,
                                    transition: 'opacity 0.2s ease'
                                }}
                            >
                                {this.state.jobsLoading ? (
                                    <>
                                        <div style={{ 
                                            width: '14px', 
                                            height: '14px', 
                                            border: '2px solid #ffffff',
                                            borderTop: '2px solid transparent',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite'
                                        }}></div>
                                        Refreshing...
                                    </>
                                ) : (
                                    <>
                                        Refresh
                                    </>
                                )}
                            </button>
                        </div>
                        
                        {this.state.jobsLoading ? (
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '40px', 
                                color: '#666',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '6px'
                            }}>
                                <div style={{ marginBottom: '12px' }}>Loading jobs...</div>
                                <div style={{ 
                                    width: '20px', 
                                    height: '20px', 
                                    border: '2px solid #f3f3f3',
                                    borderTop: '2px solid #70BB98',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite',
                                    margin: '0 auto'
                                }}></div>
                            </div>
                        ) : this.state.jobs.length === 0 ? (
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '40px', 
                                color: '#666',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '6px'
                            }}>
                                No jobs found for this agent.
                            </div>
                        ) : (
                            <div style={{ 
                                display: 'grid', 
                                gap: '12px',
                                maxHeight: '500px',
                                overflowY: 'auto'
                            }}>
                                {this.state.jobs.map(job => (
                                    <div
                                        key={job.id}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '16px 20px',
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        <div style={{ flex: 1 }}>
                                            <div style={{ 
                                                fontWeight: '600', 
                                                color: '#333',
                                                marginBottom: '8px',
                                                fontSize: '16px'
                                            }}>
                                                Job {job.job_hash}
                                            </div>
                                            <div style={{ 
                                                fontSize: '14px', 
                                                color: '#666',
                                                marginBottom: '4px'
                                            }}>
                                                Status: <span style={{ 
                                                    color: job.status === 'completed' ? '#28a745' : 
                                                          job.status === 'failed' ? '#dc3545' : 
                                                          job.status === 'running' ? '#ffc107' : '#6c757d',
                                                    fontWeight: '500'
                                                }}>
                                                    {job.status}
                                                </span>
                                            </div>
                                            <div style={{ 
                                                fontSize: '12px', 
                                                color: '#999'
                                            }}>
                                                Created: {job.created_dt ? new Date(job.created_dt).toLocaleString() : 'Unknown'}
                                            </div>
                                        </div>
                                        <div style={{ 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            gap: '8px',
                                            alignItems: 'flex-end'
                                        }}>
                                            <button
                                                onClick={() => this.handleViewJobDetails(job)}
                                                style={{
                                                    backgroundColor: '#70BB98',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    padding: '6px 12px',
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    cursor: 'pointer',
                                                    outline: 'none',
                                                    transition: 'background-color 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = '#5da085';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = '#70BB98';
                                                }}
                                            >
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                );
            default:
                return <div>No content available for this step.</div>;
        }
    }



    render() {
        const sliderStyles = `
            .custom-slider {
                -webkit-appearance: none;
                appearance: none;
                width: 100%;
                height: 6px;
                border-radius: 3px;
                background: #ddd;
                outline: none;
                cursor: pointer;
            }
            .custom-slider::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #70BB98;
                cursor: pointer;
            }
            .custom-slider::-moz-range-thumb {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #70BB98;
                cursor: pointer;
                border: none;
            }
            .custom-slider::-webkit-slider-track {
                background: #70BB98;
                height: 6px;
                border-radius: 3px;
            }
            .custom-slider::-moz-range-track {
                background: #70BB98;
                height: 6px;
                border-radius: 3px;
                border: none;
            }
        `;
        if (this.state.loading && !this.state.agent) {
            return (
                <div style={{ padding: "24px 48px" }}>
                    <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                        Loading agent details...
                    </div>
                </div>
            );
        }

        if (this.state.error && !this.state.agent) {
            return (
                <div style={{ padding: "24px 48px" }}>
                    <div style={{ 
                        backgroundColor: '#ffebee', 
                        color: '#c62828', 
                        padding: '12px', 
                        borderRadius: '4px', 
                        marginBottom: '20px' 
                    }}>
                        Error: {this.state.error}
                    </div>
                    <button onClick={this.handleBackToAgents}>
                        ← Back to Agents
                    </button>
                </div>
            );
        }

        if (!this.state.agent) {
            return (
                <div style={{ padding: "24px 48px" }}>
                    <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                        Agent not found.
                    </div>
                    <button onClick={this.handleBackToAgents}>
                        ← Back to Agents
                    </button>
                </div>
            );
        }

        return (
            <div style={{ padding: "24px 48px" }}>
                <style>{sliderStyles}</style>
                <div style={{ color: '#333', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontFamily: 'Lato', marginBottom: '20px' }}>
                    <button 
                        onClick={this.handleBackToAgents}
                        style={{
                            backgroundColor: '#fff', 
                            color: '#333', 
                            borderRadius: '5px', 
                            border: '1px solid rgb(150, 150, 160)', 
                            cursor: 'pointer', 
                            outline: 'none',
                            padding: '8px 20px',
                        }}
                    >
                        <span style={{fontSize: '16px', fontWeight: '700'}}>←</span> 
                        <span style={{fontSize: '14px', fontWeight: '500', marginLeft: '6px'}}>Agents</span> 
                    </button>
                    <h2 style={{ margin: 0, textAlign: 'center', flex: 1, padding: '0 20px' }}>{this.state.agent.agent_name}</h2>
                    <button
                        onClick={this.handleDeleteAgent}
                        disabled={this.state.loading}
                        style={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '12px 20px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: this.state.loading ? 'not-allowed' : 'pointer',
                            outline: 'none',
                            transition: 'background-color 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            if (!this.state.loading) {
                                e.target.style.backgroundColor = '#c82333';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!this.state.loading) {
                                e.target.style.backgroundColor = '#dc3545';
                            }
                        }}
                    >
                        {this.state.loading ? 'Deleting...' : 'Delete'}
                    </button>
                </div>

                {/* Horizontal line separator */}
                <div style={{ borderBottom: '1px solid #e0e0e0', marginBottom: '20px' }}></div>
                
                {/* Responsive three-column layout */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'minmax(150px, 180px) 1fr minmax(150px, 180px)', // Much smaller side columns
                    gap: '20px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    padding: '20px',
                    minHeight: '500px',
                    border: '1px solid #9696A0'
                }}>
                    {/* Left column - Menu buttons */}
                    <div style={{ backgroundColor: 'white', borderRadius: '6px', padding: '4px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}> {/* Reduced gap */}
                            <button
                                onClick={() => this.handleStepClick(1)}
                                style={{
                                    border: this.state.currentStep === 1 ? '1px solid #70BB98' : '1px solid #9696A0',
                                    borderRadius: '6px',
                                    backgroundColor: this.state.currentStep === 1 ? '#70BB98' : 'white',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    fontSize: '13px', // Slightly smaller font
                                    fontWeight: this.state.currentStep === 1 ? '600' : '400',
                                    color: this.state.currentStep === 1 ? '#FFF' : '#333',
                                    outline: 'none',
                                    padding: '8px 12px', // Reduced padding
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{fontWeight: '600'}}>Files</span>
                            </button>
                            <button
                                onClick={() => this.handleStepClick(2)}
                                style={{
                                    border: this.state.currentStep === 2 ? '1px solid #70BB98' : '1px solid #9696A0',
                                    borderRadius: '6px',
                                    backgroundColor: this.state.currentStep === 2 ? '#70BB98' : 'white',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    fontSize: '13px', // Slightly smaller font
                                    fontWeight: this.state.currentStep === 2 ? '600' : '400',
                                    color: this.state.currentStep === 2 ? '#FFF' : '#333',
                                    outline: 'none',
                                    padding: '8px 12px', // Reduced padding
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{fontWeight: '600'}}>Build</span>
                            </button>
                            <button
                                onClick={() => this.handleStepClick(3)}
                                style={{
                                    border: this.state.currentStep === 3 ? '1px solid #70BB98' : '1px solid #9696A0',
                                    borderRadius: '6px',
                                    backgroundColor: this.state.currentStep === 3 ? '#70BB98' : 'white',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    fontSize: '13px', // Slightly smaller font
                                    fontWeight: this.state.currentStep === 3 ? '600' : '400',
                                    color: this.state.currentStep === 3 ? '#FFF' : '#333',
                                    outline: 'none',
                                    padding: '8px 12px', // Reduced padding
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{fontWeight: '600'}}>API</span>
                            </button>
                            <button
                                onClick={() => this.handleStepClick(4)}
                                style={{
                                    border: this.state.currentStep === 4 ? '1px solid #70BB98' : '1px solid #9696A0',
                                    borderRadius: '6px',
                                    backgroundColor: this.state.currentStep === 4 ? '#70BB98' : 'white',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    fontSize: '13px',
                                    fontWeight: this.state.currentStep === 4 ? '600' : '400',
                                    color: this.state.currentStep === 4 ? '#FFF' : '#333',
                                    outline: 'none',
                                    padding: '8px 12px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                <span style={{fontWeight: '600'}}>Jobs</span>
                            </button>
                        </div>
                    </div>

                    {/* Middle column - Content display - Now has much more space */}
                    <div style={{ 
                        backgroundColor: 'white', 
                        borderRadius: '0px', 
                        padding: '20px', 
                        borderLeft: '1px solid #9696A0', 
                        borderRight: '1px solid #9696A0',
                        minWidth: 0,
                        overflow: 'hidden'
                    }}>
                        {this.renderStepContent()}
                    </div>

                    {/* Right column - Action buttons - Much more compact */}
                    <div style={{ backgroundColor: 'white', borderRadius: '0px', padding: '15px' }}> {/* Reduced padding */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}> {/* Reduced gap */}
                            <button
                                onClick={this.handleUndo}
                                style={{
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    padding: '10px 16px', // Reduced padding
                                    fontSize: '13px', // Slightly smaller font
                                    fontWeight: '500',
                                    cursor: 'pointer',
                                    outline: 'none',
                                    transition: 'background-color 0.2s ease',
                                    whiteSpace: 'nowrap'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#5a6268';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#6c757d';
                                }}
                            >
                                Undo
                            </button>
                            <button
                                onClick={this.handleSave}
                                disabled={this.state.loading}
                                style={{
                                    backgroundColor: '#70BB98',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    padding: '10px 16px', // Reduced padding
                                    fontSize: '13px', // Slightly smaller font
                                    fontWeight: '500',
                                    cursor: this.state.loading ? 'not-allowed' : 'pointer',
                                    outline: 'none',
                                    transition: 'background-color 0.2s ease',
                                    opacity: this.state.loading ? 0.7 : 1,
                                    whiteSpace: 'nowrap'
                                }}
                                onMouseEnter={(e) => {
                                    if (!this.state.loading) {
                                        e.target.style.backgroundColor = '#5da085';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!this.state.loading) {
                                        e.target.style.backgroundColor = '#70BB98';
                                    }
                                }}
                            >
                                {this.state.loading ? 'Saving...' : 'Save'}
                            </button>
                            
                            {/* Success message */}
                            {this.state.saveSuccess && (
                                <div style={{
                                    backgroundColor: '#d4edda',
                                    color: '#155724',
                                    border: '1px solid #c3e6cb',
                                    borderRadius: '6px',
                                    padding: '6px 10px', // Reduced padding
                                    fontSize: '11px', // Smaller font
                                    textAlign: 'center',
                                    marginTop: '6px'
                                }}>
                                    Saved successfully!
                                </div>
                            )}
                            
                            {/* Run Agent button - only show in API tab */}
                            {this.state.currentStep === 3 && (
                                <>
                                    <div style={{
                                        borderTop: '1px solid #e0e0e0',
                                        marginTop: '12px', // Reduced margin
                                        marginBottom: '6px'
                                    }}></div>
                                    
                                    <button
                                        onClick={this.handleRunAgent}
                                        disabled={this.state.runAgentLoading}
                                        style={{
                                            backgroundColor: '#70BB98',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '6px',
                                            padding: '10px 16px', // Reduced padding
                                            fontSize: '13px', // Slightly smaller font
                                            fontWeight: '500',
                                            cursor: this.state.runAgentLoading ? 'not-allowed' : 'pointer',
                                            outline: 'none',
                                            transition: 'background-color 0.2s ease',
                                            opacity: this.state.runAgentLoading ? 0.7 : 1,
                                            whiteSpace: 'nowrap'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!this.state.runAgentLoading) {
                                                e.target.style.backgroundColor = '#5da085';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!this.state.runAgentLoading) {
                                                e.target.style.backgroundColor = '#70BB98';
                                            }
                                        }}
                                    >
                                        {this.state.runAgentLoading ? 'Running...' : 'Run Agent'}
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapActionsToProps = {
    navigateTo: push
}

export default connect(null, mapActionsToProps)(AgentsUpdate)
